<script>
export default {
  inject: ["homeJumpToConsultSection"],
  data(){
    return{
      textarea2:''
    }
  },
  methods:{
    msSend1(){
      console.log("12312312321")
      this.$emit("msSend1",this.textarea2)
    },
    NavigatToConsultSection(index){
      if (typeof this.homeJumpToConsultSection === "function") {
        this.homeJumpToConsultSection(index);
      }
    }
  }

}
</script>

<template>
<div class="NaviContainer" >
  <div style="width: 80vw;height: fit-content;margin-left: 10vw;position: relative">
    <el-input style="margin-top: 4vh;border-radius: 15px" :autosize="{ minRows: 3, maxRows: 9}" type="textarea" v-model="textarea2" resize="none" placeholder="Search for any questions">

    </el-input>
    <img  @click="msSend1" style="width: 9vw;height: 9vw;position: absolute;bottom: 1.5vw;right: 1.5vw" src="@/assets/homeSend.png">
  </div>
  <div style=" height: 16vh;width: 90%;margin: auto;gap: 10px;display: grid;grid-template-columns: repeat(3,1fr);align-items: center;">
    <a class="N"  href="/openClawMobile">
      <div style="font-family: Sora;display: flex;align-items: center;gap: 6px;">
        <img class="openclaw-logo" src="@/assets/openclaw/openclaw.png" alt=""> OpenClaw
      </div>
    </a>
    <a class="N"  href="/gptAssistantsMobile">
      <div style="font-family: Sora">
        Explore AI Tool
      </div>
<!--      <div style="position: absolute;right: 4vw;top: 50%;transform: translateY(-50%)">-->
<!--        <img style="width: 4vw;height: 4vw" src="@/assets/more_btn_icon.png_white.png">-->
<!--      </div>-->

    </a>

    <a class="N" style="gap: 6px;"  href="www.linkedin.com/company/anvision-digital">
      <div >
        <img style="width: 16px;height: 16px" src="@/assets/linkin_blue.png">
      </div>
      <div style="font-family: Sora;text-align: center;">
        Follow Us!<br>Free Use!
      </div>
    </a>

  </div>

  <div class="naviBox" style="display: flex;height: fit-content;width:90%;margin: 0 auto ">
    <!--              <div style="display: flex;height: 100%;width: 26vw;align-content: center;align-items: center">-->
    <!--                <img style="height: 9vw;width: 9vw" src="@/assets/homebanner3.png">-->
    <!--                <div style="font-weight: bolder" ><span style="color: #117cd2">Anvi</span><span style="color: #f0382a">sion</span><br>Services</div>-->
    <!--              </div>-->
    <div style="height: 100%;width: 100%;">
      <div style="display: grid;gap: 2vw;grid-template-columns: repeat(2,1fr);height: fit-content">
        <div class="item" style="height: 100%;grid-column: span 2;" @click="NavigatToConsultSection(0)">
          Oil & Gas Development Engineering Digital Services
          <div class="content2">
            Full-Lifecycle Oil & Gas Digital Solutions
          </div>
        </div>
        <div class="item" style="height: 100%" @click="NavigatToConsultSection(1)">
          Oil & Gas Facility Digital Services
          <div class="content2">
            Digital Twin Platform for Oil & Gas Operations
          </div>
        </div>
        <div class="item" style="height: 100%" @click="NavigatToConsultSection(2)">
          Smart Security Services
          <div class="content2">
            Integrated Safety Solutions for Oil & Gas
          </div>
        </div>
        <div class="item" style="height: 100%" @click="NavigatToConsultSection(3)">
          New Energy Digital Services
          <div class="content2">
            Digital Solutions for Renewable Hybrid Energy
          </div>
        </div>
        <div class="item" style="height: 100%;" @click="NavigatToConsultSection(4)">
          Specialized AI Empowerment
          <div class="content2">
            Customizable Oil & Gas Digital Solutions
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<style scoped lang="scss">
.NaviContainer{
  width: 100%;
  height:fit-content;

  .item{
    font-family: Sora;
    font-weight: bolder;
    background-color: white;
    margin: 0.5vw 0.5vw;
    font-size: 3vw;
    color: black;
    text-overflow: ellipsis;
    width: 100%;
    height: fit-content;
    border-radius: 9px;
    padding: 1vh 2vw ;
    //justify-content: center;
    text-align: left;
    //display: flex;
    align-items: center;
    .content2{
      line-height:1.4;
      margin-top: 1vh;
      font-size: 2vw;
      color: gray;
    }
  }
  .N{
    display: flex;
    position: relative;
    height: 5vh;
    //background-color: white;
    //margin: 0vh 10vw;
    align-items: center;
    justify-content: center;
    // margin-top: 4vh;
    padding: 0 2vw;
    border-radius: 9px;
    background-color: #117cd1;
    background-size: cover;
    text-align: left;
    color: white;
    font-weight: bolder;
    font-size: 3vw;
    .title1{
      font-size: 6vw;
      margin-top: 4vh;
      color: #6262f0;
    }
    .title2{
      font-weight: normal;
      font-size: 4vw;
      margin-top: 2vh;
      line-height: 6vw;
      color: black;
    }

  }
  #N2{
    background-image: url("../../assets/homebanner2.jpg");
  }
  ::v-deep .el-textarea__inner{
    padding: 3vw 10vw 3vw 4vw !important;
    border-radius: 15px !important;
  }
}
@keyframes shake {
  0%, 100% {
    transform: rotate(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: rotate(-10deg);
  }
  20%, 40%, 60%, 80% {
    transform: rotate(10deg);
  }
}
.openclaw-logo{
  width: 20px;
  height: 20px;
  transform-origin: center bottom;
  animation: shake 2s infinite;
}
</style>
